import React from "react";
import Dropdown from "../ui/dropdown";
import { structureDropdowns } from "./key";

interface SearchConfigurationPanelProps {
  searchOptions: string;
  onSearchOptionsChange: (option: string) => void;
  similarity: string;
  onSimilarityChange: (value: string) => void;
  onPerformSearch: () => void;
  onResetSearch: () => void;
  openDropdownId: string | null;
  closeOtherDropdowns: (id: string | null) => void;
}

const SearchConfigurationPanel: React.FC<SearchConfigurationPanelProps> = ({
  searchOptions,
  onSearchOptionsChange,
  similarity,
  onSimilarityChange,
  onPerformSearch,
  onResetSearch,
  openDropdownId,
  closeOtherDropdowns,
}) => {
  const handleReset = () => {
    onSearchOptionsChange("substructure");
    onSimilarityChange("0.05");

    onResetSearch();
  };

  return (
    <div className="flex items-end justify-end gap-4 p-2">
      <Dropdown
        id={"searchOptionsDropdown"}
        options={[...structureDropdowns.searchOptions]}
        value={searchOptions}
        onChange={onSearchOptionsChange}
        placeholder="Structure Search Option"
        closeOtherDropdowns={() => closeOtherDropdowns("searchOptionsDropdown")}
      />
      {searchOptions === "similarity" && (
        <div className="relative">
          <p className="text-xs font-medium text-gray-500">
            Similarity Threshold
          </p>
          <input
            type="number"
            step={0.01}
            value={similarity}
            onChange={(event) => onSimilarityChange(event.target.value)}
            placeholder="e.g., 0.85"
            className="flex items-center w-32 px-3 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      )}
      <button
        type="button"
        className="px-4 py-2.5 mb-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50"
        onClick={handleReset}
      >
        Reset
      </button>
      <button
        type="button"
        className="px-4 py-2.5 mb-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 shadow-sm"
        onClick={onPerformSearch}
      >
        Search
      </button>
    </div>
  );
};

export default SearchConfigurationPanel;
